import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Router, NavigationExtras } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  Injector
} from '@angular/core';

import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import DetalheImportacaoClienteModel from '../../../../../models/importacao-cliente/detalhe-importacao-cliente.model';
import { ImportarClienteService } from '../../../importa-cliente/importar-cliente.service';
import { ModalImportaClienteComponent } from '../../../importa-cliente/modal-importa-cliente/modal-importa-cliente.component';
import { LoadingService } from '../../../../../util/loader.service';
import { ModalFormRedeSocialComponent } from './modal-form-rede-social/modal-form-rede-social.component';
import { RedesSociaisService } from './redes-sociais.service';
const swal = require('sweetalert');

@Component({
  selector: 'app-redes-sociais',
  templateUrl: './redes-sociais.component.html',
  styleUrls: ['./redes-sociais.component.scss']
})
export class RedesSociaisComponent implements OnInit {
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    descricao: "",
    ativo: true,
  };
  dados: DetalheImportacaoClienteModel
  edicao: boolean = false;
  selected = [];
  rows: Object[] = [];
  mesagensGrid = {
    'emptyMessage': 'Nenhum dado para exibir',
    'totalMessage': 'Total de registros',
    'selectedMessage': 'Selecionado'
  };
  registroSelecao = [];
  public modalRef: BsModalRef;
  parametroConsulta: string;
  acoesBottoes: boolean = true;
  sortDir: string = '';
  sortProp: string = '';
  @ViewChild('tableClientes') table: any;
  blur = false;

  ngOnDestroy(): void { }

  constructor(
    public service: RedesSociaisService,
    public injector: Injector,
    private route: ActivatedRoute,
    private router: Router,
    public loader: LoadingService,
    private modalService: BsModalService
  ) {
    this.reloadTable();
    this.parametroConsulta = '';
  }
  limparConsultaRapida() {
    this.page.descricao = '';
    this.parametroConsulta = '';
    this.page.offset = 0;
    this.page.limit = 10;
    this.reloadTable();
  }
  consultaRapida(event) {
    if (event.keyCode == 13 && this.parametroConsulta.length >= 3) {
      this.page.descricao = this.parametroConsulta.trim();
      this.page.offset = 0;
      this.limparSelecionados();
      this.reloadTable();
    }
  }


  reloadTable() {
    this.loader.show('body');
    this.service.obterTodos(this.page, this.sortDir, this.sortProp).subscribe(itens => {
      this.loader.hide('body');
      this.page.count = itens.count;
      this.rows = itens.rows;
    });
  }

  filtro(event) {
    this.page.descricao = this.parametroConsulta;
    this.reloadTable();
  }

  onFilterChange(eve: any) {
    this.page.ativo = eve;
    this.reloadTable();
  }

  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.registroSelecao = [];
    this.selected = [];
    this.reloadTable();
  }
  add(event) {
    //this.loader.show("body");
    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      class: 'modal-md',
      // size: 'lg', // sm, md, lg
      ignoreBackdropClick: true,
    };
    this.modalRef = this.modalService.show(ModalFormRedeSocialComponent, config);

    this.modalRef.content.onClose.subscribe(result => {
      this.reloadTable();
    });

  }
  remover() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      swal({
        title: 'Atenção',
        text: 'Você tem certeza que deseja remover este registro?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        closeOnConfirm: false
      }, () => {
        const id = this.registroSelecao[0].id_rede_social
        this.service.remover(id)
          .subscribe(result => {

            if (result === true) {
              this.reloadTable();

              this.limparSelecionados();
              swal('Atenção', 'Ação realizada com sucesso.', 'success');
            }
          });
      });
    }
  }
  detalhar() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      this.loader.show("body");
      this.service.detalhar(this.registroSelecao[0].id_rede_social).subscribe(itens => {

        this.loader.hide("body");

        const config: ModalOptions = {
          backdrop: 'static',
          keyboard: false,
          animated: true,
          class: 'modal-md',
          // size: 'lg', // sm, md, lg
          ignoreBackdropClick: true,
          initialState: {
            record: itens
          }
        };
        this.modalRef = this.modalService.show(ModalFormRedeSocialComponent, config);

        this.modalRef.content.onClose.subscribe(result => {
          this.limparSelecionados();
          this.reloadTable();


        });
      });
    }
  }

  ngOnInit() { }

  onSort(event) {
    this.sortDir = event.sorts[0].dir;
    this.sortProp = event.sorts[0].prop;
    this.page.offset = 0;
    this.reloadTable();
  }

  limparSelecionados() {
    this.registroSelecao = [];
    this.selected = [];
    this.acoesBottoes = true;

    this.onSelect({ selected: [] });
    this.table.selected = [];

    var inputs = document.getElementsByTagName('input');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('type') == 'checkbox') {
        inputs[i].checked = false;
      }
    }
  }
  marcarCheck(codigo) {
    let x = false;
    this.selected.forEach(item => {
      if (item.id_rede_social == codigo) {
        x = true;
      }
    });
    return x;
  }

  removeItemDuplicado(array) {
    array.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null))
    return array;
  }

  removerItem(array, item) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].id_rede_social == item[0].id_rede_social) {
        array.splice(i, 1);
      }
    }

    return array;
  }

  pegarDiferenca(r1, r2) {
    let r3 = r1.filter(a => !r2.includes(a));
    return (r3);
  }


  onSelect(event) {
    let itens = event.selected;

    let itensSemduplicacao = itens.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));

    let itemSerRemovido = this.pegarDiferenca(itens, itensSemduplicacao);
    try {
      itens = this.removerItem(itensSemduplicacao, itemSerRemovido);
    } catch (error) {
      //ignore, tudo certo
    }
    this.selected = itens;
    event.selected = itens;

    if (event.selected.length > 0) {
      this.registroSelecao = event.selected;
      this.acoesBottoes = false;
    } else {
      this.acoesBottoes = true;
    }
  }

  ativarFiltros($event) {
    this.blur = !this.blur;
  }

}
